import styled from 'styled-components';
import { Button } from 'antd';

export const Head = styled.h1`
    font-weight: 600;
    font-size: 2.375rem;
    line-height: 2.875rem;
    margin: 0;
`;

export const Content = styled.div`
    margin-top: 24px;
`;

export const BackButton = styled(Button)`
    width: 40px !important;
    height: 40px;
`;
